<!-- 项目文件 -->
<template>
<div>

    <div class="w100p pt20 ">
        <div class="w1200 mauto">
            <div class="textc mt20 mb20">
                <p class="fs36 c333 disinblock posre">
                    <span class="border-bottom1">
                        学车视频
                    </span>
                </p>
            </div>
            <div class="w100p overhidden">
                <div class="textc border2 pt16 pb16 ml10 mr10">
                    <span class="fs20 c666 ml48 mr48  cursor" @click="activeIndex(0)" :class="{'active':index==0}">科目二</span>
                    <span class="fs20 c666 ml48 mr48 cursor" @click="activeIndex(1)" :class="{'active':index==1}">科目三</span>
                </div>
                <div>
                   
                <div class="w100p pt30" v-if="index == 0">
                    <ul class="w100p disinblock ml-10">
                        <router-link to="Video" >
                            <li class="box pl20 w25p floatl disinblock posre" v-for="(item,index) in kemu2" :key="index">
                                <p class="posab bottom10  w80p over_1 textindent cfff fs14 zindex999">
                                    {{ item.title }}
                                </p>
                                <img class="minh170 img1 w100p hauto bradius15" :src="item.img" alt="">
                                <p class="posab w100p top0 left0 h100p alit">
                                    <span class="disinblock w100p textc"><img class="w28  h36 " src="../../public/img/img70.png"></span>
                                </p>
                            </li>
                        </router-link>
                    </ul>
                </div>
            
                <div class="w100p  mt20 " v-if="index == 1">
                    <ul class="w100p disinblock ml-10">
                        <router-link to="Video" >
                            <li class="box pl20 w25p floatl disinblock posre" v-for="(item,index) in kemu3" :key="index">
                                <p class="posab bottom10 w80p over_1 textindent cfff fs14 zindex999">
                                    {{ item.title }}
                                </p>
                                <img class="minh170  w100p hauto bradius15 img1" :src="item.img" alt="">
                                <p class="posab w100p top0 left0 h100p alit">
                                    <span class="disinblock w100p textc"><img class="w28  h36 " src="../../public/img/img70.png"></span>
                                </p>
                            </li>
                        </router-link>
                    </ul>
                </div>
            </div>
            <div class="textc mt20 mb20">
                <router-link to="Video" >
                    <span  class="cursor disinblock fs18 bradius8 border1f8 c1f8 pt10 pb10 pl45 pr45">查看更多>></span>
                </router-link>
            </div>
        </div>
    </div>
</div>
</div>
</template>

<script>
    export default {
        data() {
            return {
                index: 0,
                kemu2: [{
                    title: "综合教学视频",
                    img: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1545898480861.png'
                }, {
                    title: "起步时车辆后溜距离小于30cm的",
                    img: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896705490.jpg'
                }, {
                    title: "操纵转向盘手法不合理的",
                    img: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896667614.jpg'
                }, {
                    title: "起步或行驶中挂错挡，不能及时纠正的",
                    img: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896650826.jpg'
                }, ],
                kemu3: [{
                    title: "不合格情形 不按规定使用安全带或者安全头盔的",
                    img: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896060999.jpg'
                }, {
                    title: "不合格情形 道路驾驶技能考试评判标准分通用评判标准和专项评判标准",
                    img: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896047509.jpg'
                }, {
                    title: "不合格情形 遮挡、关闭车内音视频监控设备的",
                    img: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896031836.jpg'
                }, {
                    title: "不合格情形 不按考试员指令驾驶的",
                    img: 'https://image.yixueyijia.com/xconline/upload/images/article/spsy/1508896060999.jpg'
                }, ]
            };
        },
        components: {

        },
        methods: {
            activeIndex(id) {
                this.index = id;
            },
        },

        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bgcolor1 p {
        display: none;
    }
    
    .img1 {
        -webkit-filter: brightness(200%);
        filter: brightness(80%);
    }
    
    .active {
        color: #1f82f6;
        font-weight: 600;
        border-bottom: 2px solid #1f82f6;
        padding-bottom: 14px;
        padding-left: 20px;
        padding-right: 20px;
    }
</style>